const STORAGE_KEY = 'goatspins:pending-cashier';
const TTL_MS = 24 * 60 * 60 * 1000;

function canUseStorage() {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}

function isExpired(request) {
  if (!request || typeof request.createdAt !== 'number') return true;
  return Date.now() - request.createdAt > TTL_MS;
}

function isValidRequest(request) {
  if (!request || typeof request !== 'object') return false;
  if (!request.activeTab) return false;
  if (request.couponCode != null && typeof request.couponCode !== 'string') {
    return false;
  }
  if (
    request.authMode != null &&
    request.authMode !== 'login' &&
    request.authMode !== 'signup'
  ) {
    return false;
  }
  if (typeof request.createdAt !== 'number') return false;
  return true;
}

export function readPendingCashier() {
  if (!canUseStorage()) return null;

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (!isValidRequest(parsed) || isExpired(parsed)) {
      window.localStorage.removeItem(STORAGE_KEY);
      return null;
    }

    return parsed;
  } catch {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch {
      // ignore
    }
    return null;
  }
}

export function writePendingCashier(request) {
  if (!canUseStorage()) return false;

  const payload = {
    activeTab: String(request?.activeTab || '22'),
    couponCode: request?.couponCode ? String(request.couponCode) : null,
    authMode: request?.authMode === 'signup' ? 'signup' : 'login',
    createdAt:
      typeof request?.createdAt === 'number' ? request.createdAt : Date.now(),
  };

  if (!isValidRequest(payload)) return false;

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    return true;
  } catch {
    return false;
  }
}

export function clearPendingCashier() {
  if (!canUseStorage()) return;

  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

export function isPendingCashierExpired(request) {
  return isExpired(request);
}

export const PENDING_CASHIER_STORAGE_KEY = STORAGE_KEY;
export const PENDING_CASHIER_TTL_MS = TTL_MS;
